import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        sites: '=',
        defaultFilter: '=',
        list: '=',
        showFilter: '='
    },
    template: `
        <form class="form form-filter" ng-if="vm.showFilter===true" ng-submit="vm.applyFilter()">
            <div class="fields">
                <div class="row row-flex02">
                    <label class="label">{{ 'home.Filter site' | translate }}</label>
                    <div class="items">
                        <div
                            ng-dropdown-multiselect=""
                            options="vm.multiFilter.sites.options"
                            selected-model="vm.multiFilter.sites.model"
                            extra-settings="vm.multiFilter.sites.settings"
                            translation-texts="vm.filterTranslations"
                            >
                        </div>
                    </div>
                </div>
                <div class="row row-md row-flex02">
                    <label class="label">{{ 'home.Filter employee name' | translate }}</label>
                    <div class="items">
                        <input ng-model="vm.filter.name" type="text" class="form-control">
                    </div>
                </div>
                <div class="row row-flex02">
                        <label class="label">
                            {{ 'filter.Working since' | translate }}
                            <small>({{ 'filter.From' | translate }})</small>
                        </label>
                        <div class="items">
                            <datepicker-api ng-model="vm.filter.workingSinceFrom"></datepicker-api>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <label class="label">
                            {{ 'filter.Working since' | translate }}
                            <small>({{ 'filter.To' | translate }})</small>
                        </label>
                        <div class="items">
                            <datepicker-api ng-model="vm.filter.workingSinceTo"></datepicker-api>
                        </div>
                    </div>
            </div>
            <ul class="actions01">
                <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
            </ul>
        </form>
    `
})

export default class {
    constructor ($translate, lodash, FilterService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.filter = angular.copy(this.defaultFilter);
        this.initMultiFilter();
        this.filterTranslations = this.FilterService.getTranslations();
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        // NOTE: no better way to make selected options work for this retarded multiselect component
        const siteOptionsSelected = siteOptions.map(site => site);
        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.list.fetch({ pageSize: 10, expand: 'drlsWithValue,userStatistic' }, this.filter);
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.applyFilter();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/employees/filter/index.js